import * as firebase from 'firebase'
import Vue from 'vue'
import { Store } from 'vuex';
import {textToObj} from "../helpers.js"
import WreckData from '../../data/Wreck.json'
export default {
  state: {
    currentWreck:null,
    wreckDiagram:null,
    wrecks:null,
    diveModel:null,
  },
  mutations: {
    
    setDiveModel(state,payload){
      state.diveModel=payload
    },
    setWreckDiagram(state,payload){
      Vue.set(state,"wreckDiagram",payload)
      //state.wreckDiagram=payload
    },
    setWreckByName(state,payload){
      console.log("Set wreckby name",payload)
      for(var i in state.wrecks){
        if(state.wrecks[i].id==payload){
          state.currentWreck=state.wrecks[i]
          console.log("WRECK",state.currentWreck)
        }else{
        }
      }
    },
    setWreck(state,payload){
     
      console.log("SET",state.wrecks[payload])
      state.currentWreck=state.wrecks[payload]
    },
    setWrecks(state,payload){
      state.wrecks=payload
    }
  },
  actions: {
    migrate({commit},payload){
      var projectId="wreckseeker-anmm"
      console.log("OTHER APP",firebase)
      //{name:this.docName,data:this.documents})
      //console.log(JSON.parse(payload.data[0]))
      for(var i in payload.data){
        console.log(payload.data[i])
        firebase.apps[1].firestore().collection(payload.name).doc(i).set(payload.data[i])
      }
     
    },
    saveWreckData({commit},payload){
      console.log("SAVE WRECK DATA")
        commit('loading', true)
        firebase.firestore().collection("Diagrams").doc("Bomber").set(JSON.parse(payload))
      .then(function() {
        console.log("Document successfully written!");
        console.log("SAVED WRECK DATA")
        commit('loadingText',false)
      })
      .catch(function(error) {
        console.error("Error writing document: ", error);
        commit('loadingText',false)
      });
    },
   
    loadWrecks({commit,getters,dispatch}){
      let wreckText=getters.getLoadedText("Wrecks")
      var wreckObj
     
      console.log("QQQQQ ",wreckText) 
      if(WreckData){
        console.log("JJJJJJ ",WreckData) 
        wreckObj=textToObj(WreckData)
        console.log("wreckObj",wreckObj)
        commit('setWrecks',wreckObj)
      }else{
        if(!wreckText){ 
          console.log("No wreck text")
          dispatch('loadText',"Wrecks")
          setTimeout(function(){
            console.log("try again")
            dispatch('loadWrecks')
          },1000)
        }else{
          console.log("------- loadWrecks",wreckText)
          wreckObj=textToObj(wreckText)
          commit('setWrecks',wreckObj)
        // commit('setWreck', Object.keys(wreckObj)[1])
        
        }
    }
     
    }
  },
  getters: {
      getDiveModel(state,getters){
        if(getters.getWreckStatus && getters.getWreck){
          return getters.getWreckStatus[getters.getWreck.id].diveModel
        }
        //return state.diveModel
      },
      getWreck(state){
        return state.currentWreck
      },
      getWrecks(state){
        return state.wrecks
      },
      getWreckDiagram(state){
        console.log("GET getWreckDiagram",state.wreckDiagram)
        return state.wreckDiagram
      },
     
  }
}

